document.getElementById('facet-button').addEventListener('click', function (e) {
  const desktopMenu = document.getElementById('toggle-facet-menu');
  const mobileMenu = document.getElementById('toggle-facet-menu-mobile');
  if (window.PXUTheme.media_queries.medium.matches) {
    if (mobileMenu.style.display === 'none') {
      mobileMenu.style.display = 'block';
    } else {
      mobileMenu.style.display = 'none';
    }
  } else {
    if (desktopMenu.classList.contains('hidden')) {
      desktopMenu.classList.remove('hidden');
    } else {
      desktopMenu.classList.add('hidden');
    }
  }
});
